export const odooReducer = (state = {
    loading: false,
    loadingTickets: false,
    resultodoo: null,
    departments: [],
    tickets: [],
    total: 0,
    page: 1,
    pageSize: 25,
    totalPages: 0,
    messages: []
} , action) => {
    switch (action.type) {
        case 'DEPARTMENTS_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                departments: action.payload.departments
            }
        case "TICKET_SEND_SUCCESS":
            return {
                ...state,
                loading: false,
                resultodoo: action.payload.message
            }
        case 'TICKET_MESSAGES_SUCCESS':
            return {
                ...state,
                messages: action.payload
            }
        case 'ODOO_TICKETS_SUCCESS':
            return {
                ...state,
                loadingTickets: false,
                tickets: action.payload.tickets,
                total: action.payload.total,
                page: action.payload.page,
                pageSize: action.payload.pageSize,
                totalPages: action.payload.totalPages
            }
        case 'REPLY_TICKET_SUCCESS':
            return {
                ...state,
                resultodoo: 'replySuccess',
                loading: false
            }
        case 'ODOO_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'ODOO_NOT_LOADING':
            return {
                ...state,
                loading: false
            }
        case 'ODOO_RESET':
            return {
                ...state,
                loading: false,
                resultodoo: null
            }
        case 'CLEAR_MESSAGES':
            return {
                ...state,
                messages: []
            }
        case 'ODOO_TICKETS_LOADING':
            return {
                ...state,
                loadingTickets: true
            }
        case 'ODOO_TICKETS_ERROR':
            return {
                ...state,
                loadingTickets: false
            }
        default:
            return state
    }
}

